export default "__VITE_ASSET__Cnbp7mUG__"